module.exports = __webpack_public_path__ + "media/images/landing-4b40905fd60c91d4a8cb17cc2084fd5c.png";